import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type InitialResultPageRedirectStore = {
  initialResultPageRedirect: boolean;
  setInitialResultPageRedirect: (initialResultPageRedirect: boolean) => void;
};

const initialState = {
  initialResultPageRedirect: true,
};

export const useInitialResultPageRedirectStore = create<InitialResultPageRedirectStore>()(
  devtools(
    set => ({
      ...initialState,
      setInitialResultPageRedirect: (initialResultPageRedirect: boolean) => {
        set({ initialResultPageRedirect }, false, 'setInitialResultPageRedirect');
      },
    }),
    {
      name: 'initial-result-page-redirect-store',
    },
  ),
);
